module.exports = __webpack_public_path__ + "static/media/popup-tent.5c6021db.svg";